import { apiRequest } from "./httpClient";

export async function sendFriendRequest(username, token, receiverUsername) {
    return apiRequest("api/users/send-friend-req", { token, body: { username, receiverUsername } });
}

export async function confirmRequest(username, token, pendingUsername) {
    return apiRequest("api/users/confirm-req", { token, body: { username, pendingUsername } });
}

export async function ignoreFriendRequest(username, token, pendingUsername) {
    return apiRequest("api/users/ignore-friend-req", { token, body: { username, pendingUsername } });
}

export async function removeFriend(username, token, removedUsername) {
    return apiRequest("api/users/remove-friend", { token, body: { username, removedUsername } });
}

export async function cancelRequest(username, token, pendingUsername) {
    return apiRequest("api/users/cancel-req", { token, body: { username, pendingUsername } });
}

export async function getFriends(username, token) {
    return apiRequest("api/users/get-friends", { token, body: { username } });
}

export async function getIncomingRequests(username, token) {
    return apiRequest("api/users/incoming-requests", { token, body: { username } });
}

export async function blockUser(username, token, blockedUsername) {
    return apiRequest("api/users/block", { token, body: { username, blockedUsername } });
}

export async function unblockUser(username, token, blockedUsername) {
    return apiRequest("api/users/unblock", { token, body: { username, blockedUsername } });
}

export async function getBlockedUsers(username, token) {
    return apiRequest("api/users/blocked-users", { token, body: { username } });
}

// friends, incoming, outgoing, blocked - the whole Friends page in one call.
export async function getFriendsOverview(username, token) {
    return apiRequest("api/users/friends-overview", { token, body: { username } });
}

// Username/name search across everyone (20 per page). Each result says
// where it stands with you: isFriend, isSentReq (you asked), isPendingReq
// (they asked).
export async function searchUsers(username, token, entry, page = 1) {
    return apiRequest("api/users/search", { token, body: { username, entry, page } });
}

// "Tanıyor olabileceğin kişiler": [{username, fullName, imageUrl, description,
// mutualFriendCount, mutualGroupCount, mutualFriends: [first 3]}].
export async function getSuggestions() {
    return apiRequest("api/users/suggestions", { method: 'GET', token: localStorage.getItem('accessToken') });
}

export async function dismissSuggestion(username) {
    return apiRequest("api/users/suggestions/dismiss", { token: localStorage.getItem('accessToken'), body: { username } });
}

// Friends in voice right now: { [username]: { shared: false } | { shared:
// true, groupId, groupName, groupImageUrl, roomId, roomName, roomType,
// roomOwner, music, video } } - the room is only named when you're in that group.
export async function getFriendsActivity() {
    return apiRequest("api/users/friends-activity", { method: 'GET', token: localStorage.getItem('accessToken') });
}

// Star (or unstar) a friend - starred friends are listed first.
export async function setFavorite(target, favorite) {
    return apiRequest("api/users/favorite", { token: localStorage.getItem('accessToken'), body: { target, favorite } });
}
